export default {
  baseUrl: 'http://localhost:3000',
  apiBaseUrl: 'http://localhost:5001/paygr-testing/us-central1/app/api/'
};
